var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { NgZone, QueryList } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { CampaignService } from '../../services/campaign/campaign.service';
import { TranslateService } from '@ngx-translate/core';
import { CampaignItemComponent } from './campaign-item/campaign-item.component';
import { ModalService } from '../../services/modal/modal.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { CampaignInfluencerStatus, CommonConstant } from '../../app.constants';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import { AddInfluencersCampaign } from '../../../models/campaign/add-influencers-campaign';
import { ActionDetails, ActionSource, ActivePages, EventTrackerService, Page, TargetType, UserActionType, } from '../../services/event-tracker/event-tracker.service';
import { CacheService } from '../../services/cache/cache.service';
import { InvalidAction } from '../../../models/user';
import { InfluencerGroupsService } from '../influencer-groups/influencer-groups.service';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { EventFilter, EventFilterType, EventType } from '../../../models/user-notification';
import { Subject } from 'rxjs/Subject';
import { debounceTime, tap, switchMap, catchError } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { WebUtils } from '../../utils/web.utils';
import { StringUtils } from '../../utils/string.utils';
import { HttpErrorResponse } from '@angular/common/http';
var CampaignsComponent = /** @class */ (function (_super) {
    __extends(CampaignsComponent, _super);
    function CampaignsComponent(campaignService, userService, groupService, route, referenceDataService, translate, modalService, eventTracker, cacheService, router, ngZone, _location, influencerService, placeholderService) {
        var _this = _super.call(this, userService) || this;
        _this.campaignService = campaignService;
        _this.userService = userService;
        _this.groupService = groupService;
        _this.route = route;
        _this.referenceDataService = referenceDataService;
        _this.translate = translate;
        _this.modalService = modalService;
        _this.eventTracker = eventTracker;
        _this.cacheService = cacheService;
        _this.router = router;
        _this.ngZone = ngZone;
        _this._location = _location;
        _this.influencerService = influencerService;
        _this.placeholderService = placeholderService;
        _this.platformList = [];
        _this.searchCampaignList = [];
        _this.invitesCampaignList = [];
        _this.activesCampaignList = [];
        _this.historiesCampaignList = [];
        _this.currentSearchValue = '';
        _this.platformList = _this.referenceDataService.platforms;
        return _this;
    }
    CampaignsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.influencerService.cancelCurrentPreloadingRequest();
        this.numberOfLoadedCampaign = 0;
        var initialSearch = '';
        this.route.queryParams.subscribe(function (params) {
            _this._originalQueryParams = params;
            _this.selectedCampaignId = Number(params.selectedCampaign);
            if (params.search) {
                initialSearch = params.search;
            }
        });
        this.route.data.subscribe(function (data) {
            _this.enableInfluencerPlatform = data.onInfluencerPlatform;
            var currentInfluencer = _this.userService.getInfluencerInfo();
            if (_this.enableInfluencerPlatform && currentInfluencer) {
                _this.fetchCampaignBelongedToInfluencer(currentInfluencer.id);
            }
            _this.isCampaignHistory = data.isCampaignHistory ? data.isCampaignHistory : false;
            if (_this.isCampaignHistory) {
                _this.trackViewEventForCampaignHistory();
            }
        });
        // Enable removing caching data.
        // to prevent reloading list when switching back and forth between active campaigns and campaign history.
        this.cacheService.enableCacheRemoving();
        // Just support search from query params for Advertiser app
        if (this.enableInfluencerPlatform) {
            initialSearch = '';
        }
        this.setupSearchSubcription(initialSearch);
        _super.prototype.ngOnInit.call(this);
    };
    CampaignsComponent.prototype.ngOnDestroy = function () {
        if (this._searchSubscription) {
            this._searchSubscription.unsubscribe();
        }
        _super.prototype.ngOnDestroy.call(this);
    };
    CampaignsComponent.prototype.companyChangeCallback = function (companyId) {
        if (!this.enableInfluencerPlatform) {
            this.triggerSearch();
            this.userService.updateLastViewTime(EventType.NEW_CAMPAIGN_POST, companyId);
        }
    };
    CampaignsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        _super.prototype.ngAfterViewInit.call(this);
        setTimeout(function () {
            if (_this.cacheService.has('campaign_list_scroll_top')) {
                _this.cacheService.get('campaign_list_scroll_top').subscribe(function (pos) {
                    window.scrollTo(0, pos);
                });
            }
        }, 100);
    };
    CampaignsComponent.prototype.onWindowScroll = function () {
        var _this = this;
        this.ngZone.runOutsideAngular(function () {
            if (document.documentElement.scrollTop > 0) {
                _this.cacheService.set('campaign_list_scroll_top', document.documentElement.scrollTop);
            }
        });
    };
    CampaignsComponent.prototype.trackViewEventForCampaignHistory = function () {
        this.eventTracker.trackUserAction(UserActionType.VIEW, undefined, undefined, undefined, undefined, {
            type: ActivePages.CAMPAIGN_HISTORY
        });
    };
    CampaignsComponent.prototype.fetchCampaignBelongedToInfluencer = function (influencerId) {
        var _this = this;
        var data = {
            influencer_id: influencerId,
            page: 1,
            page_size: 100
        };
        // advertiser should only get campaign which belonged to the active account
        if (!this.enableInfluencerPlatform) {
            data = Object.assign({}, data, {
                company_id: this.companyId
            });
        }
        this.influencerService.getCampaignListOfInfluencer(data).subscribe(function (res) {
            var ignoredDeclinedCampaigns = res.filter(function (cp) {
                return cp.campaignType === CampaignInfluencerStatus.ARCHIVED ||
                    cp.status !== CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name.toLowerCase();
            })
                .map(function (camp) { return ({
                name: camp.name,
                id: camp.campaignId,
                campaignInfluencerId: camp.id,
                status: camp.status,
                campaignType: camp.campaignType,
                isFetchingKpi: true,
                key_search: camp.name.toLowerCase().replace(/[^a-z0-9]/g, '')
            }); });
            _this.campaignList = ignoredDeclinedCampaigns;
            _this.searchCampaignList = ignoredDeclinedCampaigns;
            _this.campaignList.forEach(function (campaign) {
                campaign.status = _this.calculateCampaignStatus(campaign.status);
                _this.fetchPostsOfInfluencerCampaign(campaign);
            });
            _this.triggerClientSearch();
        });
    };
    CampaignsComponent.prototype.fetchPostsOfInfluencerCampaign = function (camp) {
        var _this = this;
        this.influencerService.getCampaignInfluencerData(camp.campaignInfluencerId)
            .subscribe(function (res) {
            // parse post list
            var postList = res.postList.map(function (post) { return ({
                imageUrl: post.image,
                title: post.page_title,
                date: post.date,
                relativePath: post.relativePath,
                fullUrl: post.full_url,
                platformBlogs: post.platformBlogs,
                platformInstagram: post.platformInstagram,
                platformYoutube: post.platformYoutube,
                platformSnapchat: post.platformSnapchat,
                platformTwitter: post.platformTwitter,
                platformPinterest: post.platformPinterest,
                platformFacebook: post.platformFacebook,
                reach: post.reach.value,
                engagement: post.engagement.value,
                impressions: post.impression && post.impression.value > 0 ? post.impression.value : post.reach.value,
                impact: post.impact.value,
                urlHash: post.urlHash
            }); });
            camp.posts = postList;
            camp.typeName = res.campaign.brief;
            _this.campaignService.updateCampaignDetailsDataByPostList(camp);
        });
    };
    CampaignsComponent.prototype.calculateCampaignStatus = function (status) {
        var statusUppercase = ("" + status).toUpperCase();
        if (statusUppercase === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name
            || statusUppercase === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INTERESTED.name) {
            return CampaignInfluencerStatus.NEW;
        }
        else if (statusUppercase === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name) {
            return CampaignInfluencerStatus.DELETE;
        }
        else {
            return CampaignInfluencerStatus.ACTIVE;
        }
    };
    CampaignsComponent.prototype.runFetchInfluencersOfCampaignSerial = function (campaigns) {
        var _this = this;
        var result = Promise.resolve();
        campaigns.forEach(function (camp) {
            result = result.then(function () { return new Promise(function (resolve, reject) {
                _this.cacheService.get("campaign_influencers_" + camp.id, _this.campaignService.getInfluencerByCampaign(camp.id)).subscribe(function (res) {
                    _this.numberOfLoadedCampaign++;
                    _this.campaignService.updateCampaignDetailsData(camp, res);
                    _this.preloadInfluencerBelongToCampaign();
                    resolve(null);
                }, function (err) {
                    _this.numberOfLoadedCampaign++;
                    resolve(null);
                });
            }); });
        });
    };
    CampaignsComponent.prototype.preloadInfluencerBelongToCampaign = function () {
        if (this.numberOfLoadedCampaign === this.campaignList.length) {
            var influencerList_1 = [];
            this.campaignList.forEach(function (c) {
                influencerList_1.push.apply(influencerList_1, c.influencers);
            });
            this.influencerService.preloadCampaignInfluencerDataByIdList(influencerList_1, false);
        }
    };
    CampaignsComponent.prototype.showAddInfluencerToCampaigns = function () {
        if (!this.currentCampaign) {
            return false;
        }
        // open fragment
        this.isShowAddInfluencerToCampaignsFragment = true;
        this.isOpenBottomBar = true;
    };
    CampaignsComponent.prototype.showFragmentAddInfluencerManually = function (evt) {
        // clear pending influencer list
        this.pendingInfluencerListAddToCampaign = undefined;
        this.selectedInfluencerToAddCampaign = evt.selectedInfluencers;
        this.indexInfluencerManually = evt.processingIndex;
        this.processingInfluencerSuggestion = evt.influencerSuggestion;
        this.isShowAddInfluencerManuallyFragment = true;
        this.isShowAddInfluencerToCampaignsFragment = false;
        this.addInfluencerAsAccepted = evt.addInfluencerAsAccepted;
    };
    CampaignsComponent.prototype.closeFragmentAddInfluencerManually = function (influencer) {
        if (influencer) {
            this.selectedInfluencerToAddCampaign.splice(this.indexInfluencerManually, 1, influencer);
        }
        this.processingInfluencerSuggestion = null;
        this.indexInfluencerManually = null;
        this.isShowAddInfluencerToCampaignsFragment = true;
        this.isShowAddInfluencerManuallyFragment = false;
    };
    CampaignsComponent.prototype.addInfluencerToCampign = function (addInfluencerCampaign) {
        var _this = this;
        // close bottombar (Optimistic UI)
        this.closeAddInfluencerToCampaign({
            resetSelectedInfluencer: false
        });
        // hide previous notification
        this.modalService.close();
        // clear cached selected influencer suggestions
        this.selectedInfluencerToAddCampaign = [];
        // keep the list availabel influencers
        this.pendingInfluencerListAddToCampaign = addInfluencerCampaign.influencers;
        // normalize influencer list
        var newInfluencers = addInfluencerCampaign.influencers.map(function (influencer) { return ({
            domain: influencer.influencerName,
            influencer_id: influencer.influencerId,
            action: influencer.action,
            profile_image: influencer.profilePicture,
            status: influencer.status.toLowerCase()
        }); });
        var data = new AddInfluencersCampaign();
        data.campaign_id = addInfluencerCampaign.campaign_id;
        data.influencers = newInfluencers;
        var infAddedAsAccepted = addInfluencerCampaign.influencers.filter(function (item) { return item.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name; });
        // Call Api
        this.campaignService.addInfluencerToCampaign(data).subscribe(function (res) {
            _this.pendingInfluencerListAddToCampaign = undefined;
            _this.reloadSelectedCampaign(addInfluencerCampaign.campaign_id);
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
                id: _this.currentCampaign.id,
                name: _this.currentCampaign.name,
                type: TargetType.CAMPAIGN
            }, __assign({ action: UserActionType.UPDATE, actionDetails: ActionDetails.ADDED_INFLUENCERS, source: ActionSource.ACTION_VIEW }, data), undefined, {
                type: ActivePages.CAMPAIGN_OVERVIEW,
            });
            // Tracking cham event
            if (infAddedAsAccepted && infAddedAsAccepted.length === 0) {
                _this.eventTracker.trackUserAction(UserActionType.CHAM_INVITED_CAMPAIGN_INFLUENCER);
            }
            // clean cached influencer list
            _this.pendingInfluencerListAddToCampaign = [];
            _this.userService.triggerUpdateActivatedInfluencers();
        }, function (error) {
            _this.showAddInfluencerToCampaigns();
            if (error.error.data === 'invalid_level') {
                _this.userService.doInvalidActionByLevel('Add to Campaign', error.error.message);
                _this.sendInvalidActionToSegement(_this.groupService.extractLimitInfoFromErrorMessage(error.error.message, data.influencers.length, _this.userService.maxCampaignInfluencers, true), data);
            }
            else {
                _this.errorMessage = error.error.message;
                _this.modalService.open(_this.alertErrorWhenAddInfluencerToCampaign, undefined, true);
            }
        });
    };
    CampaignsComponent.prototype.sendInvalidActionToSegement = function (limitInfo, influencerAddToCampaign) {
        var detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true, limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);
        // send event when adding to Campaign
        this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.CAMPAIGN, {
            id: this.currentCampaign.id,
            name: this.currentCampaign.name,
            type: TargetType.CAMPAIGN
        }, __assign({ action: UserActionType.UPDATE, actionDetails: ActionDetails.ADDED_INFLUENCERS, source: ActionSource.ACTION_VIEW }, influencerAddToCampaign), undefined, {
            type: ActivePages.CAMPAIGN_OVERVIEW,
        });
    };
    CampaignsComponent.prototype.closeAddInfluencerToCampaign = function (data) {
        // clear up the previous influencers
        this.pendingInfluencerListAddToCampaign = undefined;
        if (data.resetSelectedInfluencer) {
            this.pendingInfluencerListAddToCampaign = [];
        }
        this.selectedInfluencerToAddCampaign = null;
        // close bottom bar
        this.isShowAddInfluencerToCampaignsFragment = false;
        this.isOpenBottomBar = false;
    };
    CampaignsComponent.prototype.onSelectCampaign = function (campaign) {
        this.currentCampaign = (campaign.is_expanded) ? null : campaign;
        this.closeAddInfluencerToCampaign({
            resetSelectedInfluencer: true
        });
        this.searchCampaignList.forEach(function (campaignItem) { return campaignItem.is_expanded = false; });
    };
    CampaignsComponent.prototype.showWarningDeleteCampaignPopup = function (campaign) {
        if (!campaign) {
            return;
        }
        this.modalService.openInCenter(this.warningCampaignDialog);
        this.campaignToDelete = campaign;
    };
    /**
     * When user accept to delete the campaign
     */
    CampaignsComponent.prototype.acceptToDeleteCampaign = function () {
        // if current user is influencer, decline this campaign
        if (this.enableInfluencerPlatform) {
            this.declineCampaign(this.campaignToDelete.campaignInfluencerId);
        }
        else if (this.isCampaignHistory) {
            // if current user is company, delete this campagin
            this.deleteCampaign();
        }
        else {
            this.archiveCampaign(this.campaignToDelete);
        }
    };
    CampaignsComponent.prototype.archiveCampaign = function (campaign) {
        var _this = this;
        this.modalService.close();
        if (campaign && campaign.status !== CampaignInfluencerStatus.ACTIVE) {
            return;
        }
        // remove camapgin on UI immediately
        var deletedCampaignIndex = this.activesCampaignList.findIndex(function (c) { return c.id === campaign.id; });
        this.activesCampaignList.splice(deletedCampaignIndex, 1);
        this.campaignService.archiveCampaign(campaign.id).subscribe(function (res) {
            campaign = null;
            _this.userService.triggerUpdateActivatedInfluencers();
        }, function (error) {
            // rollback delete campaign in previous position
            _this.activesCampaignList.splice(deletedCampaignIndex, 0, campaign);
            // show error message
            _this.errorMessage = _this.translate.instant('campaigns.archive_error');
            _this.modalService.open(_this.alertErrorWhenAddInfluencerToCampaign, _this.beforeClearErrorNotification.bind(_this), true);
        });
    };
    CampaignsComponent.prototype.deleteCampaign = function () {
        var _this = this;
        this.closeWarningDeleteICampaignPopup();
        var campaignId = this.campaignToDelete.id;
        // remove camapgin on UI immediately
        var deletedCampaignIndex = this.searchCampaignList.findIndex(function (c) { return c.id === campaignId; });
        this.searchCampaignList.splice(deletedCampaignIndex, 1);
        this.campaignService.deleteCampaign(campaignId).subscribe(function (res) {
            _this.triggerSearch();
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
                id: _this.campaignToDelete.id,
                name: _this.campaignToDelete.name,
                type: TargetType.CAMPAIGN
            }, {
                action: UserActionType.DELETE,
                source: ActionSource.PAGE,
                campaignId: campaignId
            }, undefined, {
                type: ActivePages.CAMPAIGN_OVERVIEW
            });
            _this.campaignToDelete = null;
            _this.currentCampaign = null;
        }, function (error) {
            // rollback delete campaign in previous position
            _this.searchCampaignList.splice(deletedCampaignIndex, 0, _this.campaignToDelete);
            // show error message
            _this.errorMessage = error.error.message;
            _this.modalService.open(_this.alertErrorWhenAddInfluencerToCampaign, _this.beforeClearErrorNotification.bind(_this), true);
        });
    };
    CampaignsComponent.prototype.declineCampaign = function (campaignInfluencerId) {
        var _this = this;
        this.closeWarningDeleteICampaignPopup();
        var data = {
            accessLevel: 'influencer',
            id: campaignInfluencerId,
            status: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name,
        };
        this.influencerService.updateInfluencerCampaignStatus(data).subscribe(function (res) {
            var currentInfluencer = _this.userService.getInfluencerInfo();
            _this.fetchCampaignBelongedToInfluencer(currentInfluencer.id);
        });
    };
    CampaignsComponent.prototype.closeWarningDeleteICampaignPopup = function () {
        this.modalService.close();
    };
    CampaignsComponent.prototype.beforeClearErrorNotification = function () {
        this.errorMessage = null;
    };
    CampaignsComponent.prototype.setupSearchSubcription = function (initialSearch) {
        var _this = this;
        this.currentSearchValue = initialSearch;
        this._companyIdSubject = new Subject();
        this._searchValueSubject = new BehaviorSubject(initialSearch);
        this._searchSubscription = combineLatest([
            this._companyIdSubject = new Subject(),
            this._searchValueSubject,
        ]).pipe(tap(function () {
            _this.placeholderService.show(CommonConstant.CAMPAIGN_LIST_HOLDER);
            _this.isSearching = true;
            _this.isSearchResultEmpty = false;
        }), debounceTime(700), switchMap(function (_a) {
            var companyId = _a[0], searchValue = _a[1];
            var campaignSubscriptions = [
                _this.campaignService.searchCampaigns(companyId, _this.isCampaignHistory, searchValue),
                _this.userService.getNewEventFromLastTime(EventType.NEW_CAMPAIGN_POST, companyId, _this.userService.lastViewedCampaignTime(), new EventFilter(EventFilterType.CAMPAIGN_ID))
            ];
            return forkJoin(campaignSubscriptions).pipe(tap(function (_a) {
                var data = _a[0], newEvent = _a[1];
                if (data && data.campaigns) {
                    var campaigns = data.campaigns;
                    campaigns.map(function (camp) {
                        camp.numberOfPosts = camp.totalPost;
                        camp.typeName = _this.translate.instant("campaigns." + camp.type);
                        camp.key_search = camp.name.toLowerCase().replace(/[^a-z0-9]/g, '');
                        camp.isFetchingKpi = true;
                        // auto open campaign influencer list if already selected
                        if (camp.id === _this.selectedCampaignId) {
                            camp.is_expanded = true;
                        }
                        // new posts
                        var newPublishedPosts = newEvent ? newEvent.events.find(function (evt) { return evt.key === String(camp.id); }) : null;
                        camp.newPosts = newPublishedPosts ? newPublishedPosts.value : null;
                    });
                    _this.campaignList = campaigns;
                    _this.searchCampaignList = campaigns;
                    // If selectedCampaign existed in request params, update currentCampaign based on selectedCampaign
                    // else currentCampaign is null
                    _this.currentCampaign = _this.selectedCampaignId ? (campaigns || []).find(function (cpItem) { return cpItem.id === _this.selectedCampaignId; }) : null;
                    _this.runFetchInfluencersOfCampaignSerial(_this.campaignList);
                    _this.filterCampaigns();
                    _this.updateCurrentUrlQueryParams();
                    // just show empty message and send mixpanel event when we have search value
                    if (!StringUtils.isUndefinedNullOrEmpty(_this.currentSearchValue)) {
                        _this.isSearchResultEmpty = campaigns.length === 0;
                        _this.sendSearchMixPanelEvent(campaigns.length);
                    }
                }
                _this.placeholderService.hide(CommonConstant.CAMPAIGN_LIST_HOLDER);
                _this.isSearching = false;
            }), catchError(function (error) {
                _this.handleSearchError(error);
                return of(null);
            }));
        })).subscribe();
    };
    CampaignsComponent.prototype.handleSearchError = function (error) {
        this.modalService.close();
        // Searched campaign has exceed influencer limit
        if (error && error instanceof HttpErrorResponse) {
            var data = error.error && error.error.data;
            if (data === 'influencer_exceeded') {
                this.errorMessage = this.translate.instant('campaigns.searched_campaign_exceed_influencer_limit');
                this.modalService.open(this.alertErrorWhenAddInfluencerToCampaign, null, true);
                return;
            }
        }
        // Load fail
        if (StringUtils.isUndefinedNullOrEmpty(this.currentSearchValue)) {
            this.errorMessage = this.translate.instant('campaigns.api_load_fail');
            this.modalService.openInCenter(this._searchCampaignErrorDialog);
            return;
        }
        // Search fail
        this.errorMessage = this.translate.instant('campaigns.api_search_fail');
        this.modalService.openInCenter(this._searchCampaignErrorDialog);
        WebUtils.reportErrorToSentry('Campaign search failed.', error);
    };
    CampaignsComponent.prototype.sendSearchMixPanelEvent = function (searchResultCount) {
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
            type: TargetType.CAMPAIGN
        }, {
            action: UserActionType.SEARCH,
            source: ActionSource.PAGE,
            actionDetails: ActionDetails.HANDLE_SEARCH,
            action_status: 'SUCCESS',
            action_status_details: searchResultCount
        }, undefined, {
            type: this.isCampaignHistory ? ActivePages.CAMPAIGN_HISTORY : ActivePages.CAMPAIGN_OVERVIEW,
        });
    };
    CampaignsComponent.prototype.triggerSearch = function () {
        this._companyIdSubject.next(this.companyId);
    };
    CampaignsComponent.prototype.onRetrySearch = function () {
        this.modalService.close();
        this.triggerSearch();
    };
    CampaignsComponent.prototype.onCancelSearch = function () {
        this.modalService.close();
        // show empty results
        this.searchCampaignList = [];
        this.filterCampaigns();
        this.placeholderService.hide(CommonConstant.CAMPAIGN_LIST_HOLDER);
        this.isSearching = false;
    };
    CampaignsComponent.prototype.onSearchChange = function (search) {
        this.currentSearchValue = search;
        if (this.enableInfluencerPlatform) {
            this.triggerClientSearch();
            return;
        }
        this._searchValueSubject.next(search);
    };
    CampaignsComponent.prototype.triggerClientSearch = function () {
        var search = this.currentSearchValue;
        if (search !== null && this.campaignList && this.campaignList.length > 0) {
            this.searchCampaignList.forEach(function (campaignItem) { return campaignItem.is_expanded = false; }); // deselected campaign
            this.currentCampaign = null; // reset bottom bar info
            var term_1 = search.toLowerCase().replace(/[^a-z0-9]/g, '');
            this.searchCampaignList = this.campaignList.filter(function (campaign) { return campaign.key_search.match(term_1) !== null; });
        }
        this.filterCampaigns();
    };
    CampaignsComponent.prototype.reloadSelectedCampaign = function (campaignId) {
        if (this._campaignItems && campaignId) {
            var campaignToReload = this._campaignItems.find(function (x) { return x.campaign.id === campaignId; });
            if (campaignToReload) {
                campaignToReload.reloadCampaign();
            }
        }
    };
    CampaignsComponent.prototype.editSelectedCampaign = function () {
        if (!this.currentCampaign || !this.currentCampaign.id) {
            return false;
        }
        this.sendMixpanelEvent(this.currentCampaign.id, this.currentCampaign.name);
        this.router.navigateByUrl('/campaigns/' + this.currentCampaign.id);
    };
    CampaignsComponent.prototype.newCampaign = function () {
        this.cacheService.disableCacheRemoving();
        this.router.navigateByUrl('/campaigns-add');
    };
    CampaignsComponent.prototype.openAddInfluencer = function (campaign) {
        this.currentCampaign = campaign;
        this.showAddInfluencerToCampaigns();
    };
    CampaignsComponent.prototype.openMeasurePage = function (campaign) {
        this.router.navigate(['measure'], { queryParams: { campaign_id: campaign.id } });
    };
    Object.defineProperty(CampaignsComponent.prototype, "deletedCampaignName", {
        get: function () {
            return this.campaignToDelete ? this.campaignToDelete.name : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignsComponent.prototype, "campaignBreadcrumbRoot", {
        get: function () {
            return this.isCampaignHistory ? this.translate.instant('campaigns.campaign_history') : this.translate.instant('campaigns.breadcumb_root');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignsComponent.prototype, "campaignreadcrumbSubtitle", {
        get: function () {
            return this.isCampaignHistory ? this.translate.instant('campaigns.campaign_history_subtitle') : this.translate.instant('campaigns.breadcumd_subtitle');
        },
        enumerable: true,
        configurable: true
    });
    CampaignsComponent.prototype.filterCampaigns = function () {
        var _this = this;
        this.invitesCampaignList = (this.searchCampaignList || []).filter(function (x) {
            return x.status === CampaignInfluencerStatus.NEW;
        });
        this.activesCampaignList = (this.searchCampaignList || []).filter(function (x) {
            if (_this.enableInfluencerPlatform) {
                return x.status !== CampaignInfluencerStatus.NEW && x.campaignType === CampaignInfluencerStatus.ACTIVE;
            }
            return x.status === CampaignInfluencerStatus.ACTIVE;
        });
        this.historiesCampaignList = (this.searchCampaignList || []).filter(function (x) {
            return (x.status !== CampaignInfluencerStatus.NEW
                && x.status !== CampaignInfluencerStatus.ACTIVE) || x.campaignType === CampaignInfluencerStatus.ARCHIVED;
        });
    };
    CampaignsComponent.prototype.goToCampaignHistory = function () {
        // disable caching removing,
        // to prevent reloading list when switching back and forth between active campaigns and campaign history.
        this.cacheService.enableCacheRemoving();
        return this.router.navigate(['campaigns', 'history'], {
            queryParams: {
                activeAccount: this.companyId
            }
        });
    };
    CampaignsComponent.prototype.backToCampaignPage = function () {
        // disable caching removing,
        // to prevent reloading list when switching back and forth between active campaigns and campaign history.
        this.cacheService.enableCacheRemoving();
        return this.router.navigate(['campaigns'], {
            queryParams: {
                activeAccount: this.companyId
            }
        });
    };
    CampaignsComponent.prototype.sendMixpanelEvent = function (campaignId, campaignName) {
        this.eventTracker.trackUserAction(UserActionType.VIEW, Page.CAMPAIGN, {
            id: campaignId,
            name: campaignName,
            type: TargetType.CAMPAIGN
        });
    };
    Object.defineProperty(CampaignsComponent.prototype, "acceptBtnLabel", {
        get: function () {
            if (this.enableInfluencerPlatform || this.isCampaignHistory) {
                return this.translate.instant('common.btn.delete_confirm_ok');
            }
            else {
                return this.translate.instant('common.btn.archive_confirm_ok');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignsComponent.prototype, "acceptCancelLabel", {
        get: function () {
            if (this.enableInfluencerPlatform || this.isCampaignHistory) {
                return this.translate.instant('common.btn.delete_campaign_cancel');
            }
            else {
                return this.translate.instant('common.btn.cancel');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignsComponent.prototype, "warningDeleteCampaignMessage", {
        get: function () {
            if (this.enableInfluencerPlatform || this.isCampaignHistory) {
                return this.translate.instant('campaigns.delete_warning_message', {
                    campaignName: this.deletedCampaignName
                });
            }
            else {
                return this.translate.instant('campaigns.archive_warning_message');
            }
        },
        enumerable: true,
        configurable: true
    });
    CampaignsComponent.prototype.goToCampaignDetails = function (campaignId) {
        var goToCampaignDetailsQueryParams = {
            activeAccount: this.userService.getCompanyId(),
            selectedCampaign: campaignId
        };
        if (!StringUtils.isUndefinedNullOrEmpty(this.currentSearchValue)) {
            goToCampaignDetailsQueryParams = __assign({}, goToCampaignDetailsQueryParams, { search: this.currentSearchValue });
        }
        this.router.navigate(['campaigns', campaignId, 'influencer-list'], { queryParams: goToCampaignDetailsQueryParams });
    };
    CampaignsComponent.prototype.updateCurrentUrlQueryParams = function () {
        var queryParams = __assign({}, this._originalQueryParams);
        if (StringUtils.isUndefinedNullOrEmpty(this.currentSearchValue)) {
            queryParams.search = undefined;
        }
        else {
            Object.assign(queryParams, { search: this.currentSearchValue });
        }
        var baseRouteUrl = this.router.url.split('?')[0];
        var url = this.router.createUrlTree([baseRouteUrl], { queryParams: queryParams }).toString();
        this._location.replaceState(url);
    };
    return CampaignsComponent;
}(AbstractAchooComponent));
export { CampaignsComponent };



// WEBPACK FOOTER //
// ./src/app/main/campaigns/campaigns.component.ts.pre-build-optimizer.js